import { translate, updateInterpolationParams, configQuery, setInterpolationParams, ipCountryQuery } from '@gig/magic-common';
import { __awaiter, __generator, __assign } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { meta } from '../services/meta/meta.service.js';
import { getMetaTags } from './meta.js';

/**
 * Given the user's current loyalty level and the loyalty tiers configuration
 * the function returns the current loyalty tier for the logged in user.
 * Any unexpected conditions (missing config, wrong config ...) will default to 0.
 *
 * @param level current user's loyalty level
 * @param tiers loyalty tiers configuration
 *
 * @returns the current user loyalty tier
 */
function calculateLoyaltyTier(level, tiers) {
    if (level < 0 || !tiers || tiers.length === 0) {
        return 0;
    }
    var tierIndex = tiers.findIndex(function (curr) {
        return level >= curr.min && (curr.max === undefined || level <= curr.max);
    });
    return tierIndex > 0 ? tierIndex : 0;
}
function setMetaInformation() {
    getMetaTags().forEach(function (_a) {
        var name = _a.name, content = _a.content;
        meta.setDefaultTagInformation({
            name: name,
            content: translate(content),
        });
    });
    meta.setTitle(translate('meta.default.title'));
}
function initWakeLock() {
    if ('wakeLock' in navigator) {
        navigator.wakeLock.request('screen');
    }
}
/**
 * Add user data to translations interpolation parameters
 */
function setUserInterpolationParams() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var user, userParams, userInterpolationParams, interpolationParams, visitorParams;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    user = magic.session.getUser();
                    userParams = {};
                    if (user) {
                        userInterpolationParams = [
                            'userName',
                            'country',
                            'currency',
                            'email',
                            'firstName',
                            'lastName',
                            'roles',
                        ];
                        userParams = userInterpolationParams.reduce(function (params, field) {
                            var _a;
                            return (__assign(__assign({}, params), (_a = {}, _a[field] = user[field] || field, _a)));
                        }, {});
                    }
                    return [4 /*yield*/, configQuery('interpolationParams')];
                case 1:
                    interpolationParams = _c.sent();
                    _b = {};
                    return [4 /*yield*/, ipCountryQuery()];
                case 2:
                    visitorParams = (_b.country = (_a = (_c.sent())) !== null && _a !== void 0 ? _a : '',
                        _b);
                    setInterpolationParams(__assign(__assign({}, interpolationParams), Object.assign(visitorParams, userParams)));
                    return [2 /*return*/];
            }
        });
    });
}
function setLoyaltyInterpolationParams(progress, level, points) {
    return __awaiter(this, void 0, void 0, function () {
        var loyaltyTiers, loyaltyTierIndex, loyaltyTier;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, configQuery('loyalty.tiers')];
                case 1:
                    loyaltyTiers = _a.sent();
                    loyaltyTierIndex = calculateLoyaltyTier(level, loyaltyTiers).toString();
                    loyaltyTier = translate("loyalty.tiers.tier-" + loyaltyTierIndex);
                    updateInterpolationParams({
                        loyaltyLevel: level.toString(),
                        loyaltyBalance: points.toString(),
                        loyaltyProgress: Math.floor(progress).toString(),
                        loyaltyTier: loyaltyTier,
                    });
                    return [2 /*return*/];
            }
        });
    });
}

export { calculateLoyaltyTier, initWakeLock, setLoyaltyInterpolationParams, setMetaInformation, setUserInterpolationParams };
